import { shape } from 'prop-types';
import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';

import bgImage from './login-bg.svg';
import logoUrl from '../../images/metso-main-logo-pack-20230621/Metso_Logo_Black_RGB.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom right;
  background-image: url(${bgImage});
`;

const Title = styled.h1`
  font-size: 2.25rem;
  font-weight: 200;
  margin-top: 0;
  margin-bottom: 30px;
`;

const TitleSmall = styled.p`
  font-size: 1.375rem;
  font-weight: 600;
  margin-bottom: 0px;
`;

const Logo = styled.img`
  position: absolute;
  top: 20px;
  left: 20px;
  width: 80px;
`;

const BuildId = styled.div`
  font-size: 12px;
  position: absolute;
  bottom: 10px;
  color: rgba(255, 255, 255, 1);
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
`;

const propTypes = {
  history: shape({}).isRequired,
};

const LoginContainer = ({ history }) => {
  const { t } = useTranslation('common');
  const { loginWithRedirect, isAuthenticated, isLoading, user, error } =
    useAuth0();

  // If user is authenticated, show welcome message
  if (isAuthenticated && user) {
    return (
      <Container>
        <Logo alt="Metso Logo" src={logoUrl} />
        <TitleSmall>{t('common:strings.welcomeTo', 'Welcome to')}</TitleSmall>
        <Title>Crusher Wears Value Optimizer</Title>
        <ButtonContainer>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => (window.location.href = '/')}
          >
            Go to Dashboard
          </Button>
        </ButtonContainer>
        <BuildId>{process.env.REACT_APP_BUILD_ID}</BuildId>
      </Container>
    );
  }

  // If loading
  if (isLoading) {
    return (
      <Container>
        <Logo alt="Metso Logo" src={logoUrl} />
        <TitleSmall>Loading...</TitleSmall>
        <Title>Please wait</Title>
        <BuildId>{process.env.REACT_APP_BUILD_ID}</BuildId>
      </Container>
    );
  }

  // If error
  if (error) {
    return (
      <Container>
        <Logo alt="Metso Logo" src={logoUrl} />
        <TitleSmall>Authentication Error</TitleSmall>
        <Title>{error.message}</Title>
        <ButtonContainer>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </ButtonContainer>
        <BuildId>{process.env.REACT_APP_BUILD_ID}</BuildId>
      </Container>
    );
  }

  // Login button
  return (
    <Container>
      <Logo alt="Metso Logo" src={logoUrl} />
      <TitleSmall>{t('common:strings.welcomeTo', 'Welcome to')}</TitleSmall>
      <Title>Crusher Wears Value Optimizer</Title>
      <Button
        id="auth0LoginBtn"
        variant="contained"
        color="primary"
        size="large"
        onClick={() => loginWithRedirect()}
      >
        {t('common:buttons.loginWithMetso', 'Login with Metso account')}
      </Button>
      <BuildId>{process.env.REACT_APP_BUILD_ID}</BuildId>
    </Container>
  );
};

LoginContainer.propTypes = propTypes;

export default LoginContainer;
